export class GetDesignPressureResponseDto {
  designId?: number;
  rightCenterPointX?: number;
  rightCenterPointZ?: number;
  rightRotationPointX?: number;
  rightRotationPointZ?: number;
  leftCenterPointX?: number;
  leftCenterPointZ?: number;
  leftRotationPointX?: number;
  leftRotationPointZ?: number;

  constructor(init?: Partial<GetDesignPressureResponseDto>) {
    if (init) Object.assign(this, init);
  }

  toPressureAlignment() {
    return new PressureAlignment(this);
  }
}

export class PressureAlignment {
  designId?: number;
  rightCenterPointX?: number;
  rightCenterPointZ?: number;
  rightRotationPointX?: number;
  rightRotationPointZ?: number;
  leftCenterPointX?: number;
  leftCenterPointZ?: number;
  leftRotationPointX?: number;
  leftRotationPointZ?: number;

  constructor(init?: Partial<PressureAlignment>) {
    if (init) Object.assign(this, init);
  }
}

export class DesignPressureAlignmentRequestDto {
  rightCenterPointX?: number;
  rightCenterPointZ?: number;
  rightRotationPointX?: number;
  rightRotationPointZ?: number;
  leftCenterPointX?: number;
  leftCenterPointZ?: number;
  leftRotationPointX?: number;
  leftRotationPointZ?: number;

  constructor(init?: Partial<DesignPressureAlignmentRequestDto>) {
    if (init) Object.assign(this, init);
  }
}
